export default {
    STATE_LIST: [
        {"label": "Alabama", "code": "AL"},
        // {"label": "Alaska", "code": "AK"},
        {"label": "Arizona", "code": "AZ"},
        {"label": "Arkansas", "code": "AR"},
        {"label": "California", "code": "CA"},
        {"label": "Colorado", "code": "CO"},
        {"label": "Connecticut", "code": "CT"},
        {"label": "Delaware", "code": "DE"},
        {"label": "District Of Columbia", "code": "DC"},
        {"label": "Florida", "code": "FL"},
        {"label": "Georgia", "code": "GA"},
        // {"label": "Hawaii", "code": "HI"},
        {"label": "Idaho", "code": "ID"},
        {"label": "Illinois", "code": "IL"},
        {"label": "Indiana", "code": "IN"},
        {"label": "Iowa", "code": "IA"},
        {"label": "Kansas", "code": "KS"},
        {"label": "Kentucky", "code": "KY"},
        {"label": "Louisiana", "code": "LA"},
        {"label": "Maine", "code": "ME"},
        {"label": "Maryland", "code": "MD"},
        {"label": "Massachusetts", "code": "MA"},
        {"label": "Michigan", "code": "MI"},
        {"label": "Minnesota", "code": "MN"},
        {"label": "Mississippi", "code": "MS"},
        {"label": "Missouri", "code": "MO"},
        {"label": "Montana", "code": "MT"},
        {"label": "Nebraska", "code": "NE"},
        {"label": "Nevada", "code": "NV"},
        {"label": "New Hampshire", "code": "NH"},
        {"label": "New Jersey", "code": "NJ"},
        {"label": "New Mexico", "code": "NM"},
        {"label": "New York", "code": "NY"},
        {"label": "North Carolina", "code": "NC"},
        {"label": "North Dakota", "code": "ND"},
        {"label": "Ohio", "code": "OH"},
        {"label": "Oklahoma", "code": "OK"},
        {"label": "Oregon", "code": "OR"},
        {"label": "Pennsylvania", "code": "PA"},
        {"label": "Rhode Island", "code": "RI"},
        {"label": "South Carolina", "code": "SC"},
        {"label": "South Dakota", "code": "SD"},
        {"label": "Tennessee", "code": "TN"},
        {"label": "Texas", "code": "TX"},
        {"label": "Utah", "code": "UT"},
        {"label": "Vermont", "code": "VT"},
        {"label": "Virginia", "code": "VA"},
        {"label": "Washington", "code": "WA"},
        {"label": "West Virginia", "code": "WV"},
        {"label": "Wisconsin", "code": "WI"},
        {"label": "Wyoming", "code": "WY"},
        {"label": "Armed Forces (AA)", "code": "AA"},
        {"label": "Armed Forces (AE)", "code": "AE"},
        {"label": "Armed Forces (AP)", "code": "AP"}
    ],
    NAV_FLICKITY_OPTIONS: {
        asNavFor: '.carousel-main',
        contain: true,
        pageDots: false
    },
    MAIN_FLICKITY_OPTIONS: {
        arrowShape: 'M504 256C504 119 393 8 256 8S8 119 8 256s111 248 248 248 248-111 248-248zM256 472c-118.7 0-216-96.1-216-216 0-118.7 96.1-216 216-216 118.7 0 216 96.1 216 216 0 118.7-96.1 216-216 216zm-12.5-92.5l-115.1-115c-4.7-4.7-4.7-12.3 0-17l115.1-115c4.7-4.7 12.3-4.7 17 0l6.9 6.9c4.7 4.7 4.7 12.5-.2 17.1L181.7 239H372c6.6 0 12 5.4 12 12v10c0 6.6-5.4 12-12 12H181.7l85.6 82.5c4.8 4.7 4.9 12.4.2 17.1l-6.9 6.9c-4.8 4.7-12.4 4.7-17.1 0z',
    }
}
